<div
  class="rn-image-uploader"
  [class.rn-image-uploader--dragging]="dragging()"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave()"
  (drop)="onDrop($event)"
>
  <div class="rn-image-uploader__dropzone">
    <p class="rn-image-uploader__hint">Drag and drop images here, or</p>
    <label class="rn-image-uploader__browse">
      <input type="file" accept="image/*" multiple hidden (change)="onFileSelected($event)" />
      <span class="cg-btn cg-btn-secondary cg-btn--sm">Choose files</span>
    </label>
    @if (uploading()) {
      <p class="cg-form-help">Uploading…</p>
    }
    @if (uploadError()) {
      <p class="cg-form-error">{{ uploadError() }}</p>
    }
  </div>

  @if (imageUrls().length > 0) {
    <div class="rn-image-uploader__thumbs" cdkDropList (cdkDropListDropped)="onReorder($event)">
      @for (url of imageUrls(); track url; let i = $index) {
        <div class="rn-image-uploader__thumb" cdkDrag>
          <img [src]="url" alt="" class="rn-image-uploader__preview" />
          <div class="rn-image-uploader__actions">
            <label class="rn-image-uploader__action-btn" title="Replace">
              <input type="file" accept="image/*" hidden (change)="replaceAt(i, $event)" />
              Replace
            </label>
            <button type="button" class="rn-image-uploader__action-btn" (click)="removeAt(i)">Delete</button>
          </div>
        </div>
      }
    </div>
  }
</div>
